import { useEffect, useState } from 'react';

// Ticking elapsed-time hook shared by every DFT/lattice progress surface:
// DftAsyncPanel (src/AppShell.jsx) and LatticeWizard's dft_running and
// generating phases (src/components/LatticeWizard.jsx).
//
// `startMs` is an epoch-ms timestamp (Date.now()-style): either the moment
// this surface submitted the job/run, or, when resuming an in-flight job via
// dftJobRegistry, the job's original submittedAt, so a reopened panel's timer
// reflects how long the job has actually been running rather than resetting
// to zero. Pass null/undefined while the start time isn't known yet; the hook
// returns null in that case and renders nothing.
//
// Format: under 1 hour "Xm Ys", at or over 1 hour "Xh Ym". No em dashes.
export function useElapsed(startMs) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!startMs) return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [startMs]);
  if (!startMs) return null;
  const totalSeconds = Math.max(0, Math.floor((now - startMs) / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m ${seconds}s`;
}
